export const isProduction = import.meta.env.VITE_ENVIRONMENT === 'production'
